import React from "react";
import AnimateLine from "../../common/AnimateLine";
import Breadcrumb from "../../common/Breadcrumb";
import SubscribArea from "../../common/SubscribArea";
import ProjectWrap from "./ProjectWrap";

function Project() {
  return (
    <>
      <div className="ebrandy-wrap">
        <AnimateLine />
        <Breadcrumb pageName="Proiecte" pageTitle="Proiecte" />
        <ProjectWrap />
        <SubscribArea />
      </div>
    </>
  );
}

export default Project;
